import { IconButton } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import MaterialTable, { MTableToolbar } from 'material-table';
import React, { useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import AdvanceTable from '../../components/advance-table/AdvanceTable';
import AdvanceTablePagination from '../../components/advance-table/AdvanceTablePagination';
import AdvanceTableWrapper from '../../components/advance-table/AdvanceTableWrapper';
import { NotificationManager } from '../../components/common/react-notifications';
import TooltipItem from '../../components/common/TooltipItem';
import {
  formatUrl,
  getFormattedDateString,
  getFormattedStatus,
  isFunctionalComponent,
} from '../../helpers/utils';

const getActionButtonCol = (label, target, onClick) => ({
  title: '',
  field: '',
  render: (row) => (
    <a
      href={'#'}
      className='btn-link'
      color='link'
      onClick={(e) => {
        e.preventDefault();
        if (onClick) {
          onClick(row.tableData.id, row.id, target);
        }
      }}
    >
      {label}
    </a>
  ),
});

const getBuyButtonCol = (label) => ({
  title: '',
  field: '',
  render: (row) => (
    <a
      href={'#'}
      className='btn-link'
      color='link'
      onClick={(e) => {
        e.preventDefault();
        if (row.shopify_product_url !== null) {
          window.open(
            `${formatUrl(row.shopify_product_url)}?action=buy_item`,
            'noopener noreferrer'
          );
        } else {
          NotificationManager.error({ message: 'Cannot open url' });
        }
      }}
    >
      {label}
    </a>
  ),
});

export const RentalsTable = ({
  loadingRentals,
  rentals,
  additionalToolbarComponent,
  additionalHeaderComponent,
  handleOpenDetail,
  handleRefresh,
  columns,
}) => {
  const [pageSizeValue, setPageSizeValue] = useState(15);
  // const getFormattedDateString = (dateString) => {
  //   if (!dateString) return "";
  //   let splitted = dateString.split("-");
  //   return `${splitted[1]}/${splitted[2]}/${splitted[0]}`;
  // };

  const ToolbarComponent = (props) => (
    <div className='table-custome-toolbar'>
      <div className='table-toolbar-select '>
        <div className='header'>
          <h2 className='' style={{ fontFamily: 'Brown', color: '#C98B76' }}>
            My Rentals
          </h2>
          {isFunctionalComponent(additionalHeaderComponent)
            ? additionalHeaderComponent(props)
            : null}
        </div>
      </div>
      <div className='common-table-toolbar-component relative'>
        <>
          <TooltipItem
            item={{
              placement: 'bottom',
              text: 'Refresh',
            }}
            id={`tooltip_refresh`}
          />
          <IconButton
            aria-label='refresh table'
            component='span'
            onClick={handleRefresh}
            id={`tooltip_refresh`}
          >
            <Refresh />
          </IconButton>
        </>
        <MTableToolbar {...props} searchFieldStyle={{ fontFamily: 'Brown' }} />
      </div>
    </div>
  );

  const HeaderComponent = (props) => (
    <div className='header'>
      <h2 className=''>My Rentals</h2>
      {isFunctionalComponent(additionalHeaderComponent)
        ? additionalHeaderComponent(props)
        : null}
    </div>
  );

  const getColumns = () => {
    const columns = [
      {
        title: '',
        field: '',
        headerStyle: { whiteSpace: 'nowrap' },

        render: (row) => (
          <img
            className='product-table-image'
            src={row.img_url}
            alt={row.title}
            loading={'lazy'}
          />
        ),
      },
      {
        title: 'ID',
        field: 'id',
      },
      {
        title: 'Title',
        field: 'title',

        cellStyle: {
          width: 1000,
          maxWidth: 1000,
        },
        headerStyle: {
          width: 1000,
          maxWidth: 1000,
        },
      },
      {
        title: 'Rented On',
        field: 'consigned_on',
        cellStyle: { whiteSpace: 'nowrap' },
        headerStyle: { whiteSpace: 'nowrap' },
        render: (row) => {
          return getFormattedDateString(row.last_rented_on) || '-';
        },
      },

      {
        title: 'Status',
        field: 'status',
        render: (row) => getFormattedStatus(row.status),
      },
    ];

    columns.push(getActionButtonCol('Details', 'details', handleOpenDetail));
    columns.push(getActionButtonCol('Return', 'return', handleOpenDetail));
    columns.push(getActionButtonCol('Review', 'review', handleOpenDetail));
    columns.push(getBuyButtonCol('Buy'));
    return columns;
  };

  if (loadingRentals) {
    return (
      <div
        className='loading-overlay'
        style={{ backgroundColor: 'transparent' }}
      >
        <div className='loading'></div>
      </div>
    );
  } else {
    return (
      <AdvanceTableWrapper
        columns={columns}
        data={rentals}
        pagination={rentals.length > 15}
        perPage={pageSizeValue}
        sortable={true}
      >
        <AdvanceTable
          table
          headerClassName='text-400 text-nowrap align-middle'
          rowClassName='align-middle white-space-nowrap'
          tableProps={{
            bordered: false,
            striped: false,
            loader: loadingRentals,
            className: 'fs--1 mb-0 overflow-x-auto',
          }}
        />
        {rentals.length > 15 ? (
          <div className='my-5'>
            <AdvanceTablePagination
              table
              rowsPerPageSelection
              setPageSize={(value) => setPageSizeValue(value)}
              pageSize={pageSizeValue}
            />
          </div>
        ) : null}
      </AdvanceTableWrapper>
    );
  }
};
